<div cdkDropList
  cdkDropListLockAxis="y"
  (cdkDropListDropped)="onDrop($event)"
  >
  <div cdkDropListGroup
    class="section-group">
    <div cdkDrag
      *ngFor="let section of sections$|async; let i = index; trackBy: sectionTrackBy" 
      class="section">
      <div *cdkDragPlaceholder
        class="section-placeholder"></div>

      <div cdkDragHandle
        class="section-handle">
        <mat-icon inline color="primary">drag_indicator</mat-icon>
      </div>

      <div class="section-content">
        <div class="section-name">
          <div>
            <mat-checkbox 
              [checked]="section.included"
              [disabled]="section.disabled"
              (change)="onSectionCheckboxChange($event, section.id)"></mat-checkbox>
            <div>
              <input 
                class="name-input section-name-input"
                [value]="section.name"
                (input)="onSectionNameChange($event, section.id)"
              />
            </div>
          </div>
          <div class="name-reset-container" *ngIf="section.defaultName && (section.name !== section.defaultName)">
            <span>
              {{ section.defaultName }}
            </span>
            <button mat-icon-button type="button" (click)="onSectionNameResetToDefault(section.id)">
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>
          <div class="delete-container" *ngIf="!section.defaultName && section.chapters.length === 0">
            <button type="button" mat-icon-button (click)="onDeleteSection(section.id)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div cdkDropList 
          [id]="section.id" 
          [cdkDropListData]="section"
          (cdkDropListDropped)="onChapterDrop($event)"
          [cdkDropListEnterPredicate]="predicate"
          class="section-chapters">
          <div cdkDrag 
            *ngFor="let chapter of section.chapters; trackBy: chapterTrackBy"
            [cdkDragData]="chapter"
            class="section-chapter-container">
            <div *cdkDragPlaceholder
              class="section-chapter-placeholder"></div>

            <div cdkDragHandle
              class="section-chapter-handle">
              <mat-icon inline>menu</mat-icon>
            </div>

            <div class="section-chapter">
              <div class="section-chapter-name">
                <div>
                  <mat-checkbox 
                    [checked]="chapter.included"
                    (change)="onChapterCheckboxChange($event, section.id, chapter.id)"></mat-checkbox>
                  <div>
                    <input 
                      class="name-input"
                      [value]="chapter.name"
                      (input)="onChapterNameChange($event, section.id, chapter.id)"
                    />
                  </div>
                </div>
                <div class="name-reset-container" *ngIf="chapter.defaultName && (chapter.name !== chapter.defaultName)">
                  <span>
                    {{ chapter.defaultName }}
                  </span>
                  <button mat-icon-button type="button" (click)="onChapterNameResetToDefault(section.id, chapter.id)">
                    <mat-icon>restart_alt</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div 
            *ngIf="section.chapters.length === 0" 
            style="height: 20px"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>